import API from './settings'

// Company
export const filterCompanies = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/company/filter`, formData);
};

export const getCompany = (project_code: string, company_code: string): any => {
    return API.get(`/${project_code}/company/get/${company_code}`);
};

export const createCompany = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/company/create`, formData);
};

export const editCompany = (project_code: string, company_code: string, formData: any): any => {
    return API.post(`/${project_code}/company/edit/${company_code}`, formData);
};

export const removeCompany = (project_code: string, company_code: string): any => {
    return API.post(`/${project_code}/company/delete/${company_code}`);
};

// Area
export const filterAreas = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/area/filter`, formData);
};

export const getArea = (project_code: string, area_id: string): any => {
    return API.get(`/${project_code}/area/get/${area_id}`);
};

export const createArea = (project_code: string, formData: any): any => {
    return API.post(`/${project_code}/area/create`, formData);
};

export const editArea = (project_code: string, area_code: string, formData: any): any => {
    return API.post(`/${project_code}/area/edit/${area_code}`, formData);
};

export const removeArea = (project_code: string, area_code: string): any => {
    return API.post(`/${project_code}/area/delete/${area_code}`, {});
};

export const getPendingTasks = (): any => {
    return API.get('/ALL/area/notif/get_pending_tasks');
};
